import { CSSProperties } from 'react'

const compose = (...functions: any[]) => (args: any) => functions.reduce((arg, fn) => fn(arg), args)
export default compose

export function createStyleMap<T extends { [name: string]: CSSProperties }>(cfg: T) {
  return cfg
}
